import { render, staticRenderFns } from "./GetProperties.vue?vue&type=template&id=21a937fc&scoped=true"
import script from "./GetProperties.vue?vue&type=script&lang=js"
export * from "./GetProperties.vue?vue&type=script&lang=js"
import style0 from "./GetProperties.vue?vue&type=style&index=0&id=21a937fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a937fc",
  null
  
)

export default component.exports